<template>
  <d-modal @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('marketing.sendTestEmail') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <validation-observer
          ref="test-email-form"
          tag="form">
          <div class="form-group">
            <label for="test-email">
              {{ $t('marketing.testEmailAddress') }}:
            </label>

            <validation-provider
              rules="required|email"
              name="email"
              v-slot="{ errors }">
              <d-input
                id="test-email"
                :state="errors.length ? 'invalid' : null"
                v-model="email"
                :disabled="sending" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="handleClose">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        :disabled="sending"
        @click.prevent="validateForm">
        {{ $t('marketing.sendTestEmail') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from '@/utils/FormUtils.js';

export default {
  name: 'mailing-test-popup',
  props: {
    content: {
      default: '',
      type: String
    },
    subject: {
      default: '',
      type: String
    }
  },
  data () {
    return {
      email: '',
      sending: false
    };
  },
  methods: {
    handleClose () {
      this.$bus.$emit('mailing-test-popup-close');
    },
    validateForm () {
      FormUtils.validate(this.$refs['test-email-form'], this.sendTestEmail);
    },
    sendTestEmail () {
      this.sending = true;

      FormUtils.submit({
        $http: this.$http,
        endpoint: '/marketing/mailings/send-test',
        formData: {
          email: this.email,
          subject: this.subject,
          content: this.content
        },
        successTitle: this.$t('marketing.testEmailSuccessTitle'),
        successText: this.$t('marketing.testEmailSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('marketing.testEmailErrorText'),
        successAction: () => {
          this.sending = false;
          this.handleClose();
        },
        failAction: () => {
          this.sending = false;
        }
      });
    }
  }
}
</script>
